import isArray from 'lodash/isArray'

export default function mergeCopyArrays (objValue: any, srcValue: any) {
  if (isArray(objValue)) {
    return srcValue
  }
}
